
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import { commonModule, companyModule, installationsModule, itemsModule } from '@/store/modules/store-accessor'
import { pagesExportLimit, templatesFilenameLanguage } from "@/helpers/data";
import dayjs from 'dayjs';
import FileSaver from 'file-saver';

import InstallationsItems from '@/components/Expansions/InstallationsItems.vue'
import ExportMenu from "@/components/ExportMenu/ExportMenu.vue";

@Component({
  components: {
    InstallationsItems,
    ExportMenu,
  },
})
export default class InstallationsSideviewItemsTab extends Vue {
 @Prop() installation: Record<string, any>;

  isDownloadingExport = false;

  mounted() {
    commonModule.getPersonnelCombo();
    commonModule.getActionCombo();
    itemsModule.getAllInventoryItems('');
    commonModule.getFuelTypeCombo();
    commonModule.getPlacementTypeCombo();
  }

  @Watch("installation.info.id")
  updateItems() {
    commonModule.getPersonnelCombo();
    commonModule.getActionCombo();
    itemsModule.getAllInventoryItems('');
    commonModule.getFuelTypeCombo();
    commonModule.getPlacementTypeCombo();
  }

  get items() {
    if(!this.installation.items) return [];

    const activeItems = this.installation.items;
    return activeItems.sort((a: any, b: any) => {
          const c: any = new Date(a.created_at);
          const d: any = new Date(b.created_at);
          return d - c;
    });
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDate(date)
  }

  addInstallationItem(){
    commonModule.showModal({ name: 'add-installation-item-modal', payload: { installation: this.installation }})
  }

  downloadExportLengthCheck(type: string) {
    if (type === 'pdf') {
      return this.items?.length > 0 && this.items?.length <= pagesExportLimit();
    }
    return this.items?.length > 0;
  }

  async donwloadItemsExport(format: string) {
    this.isDownloadingExport = true;
    const data = {
      user_timezone: dayjs.tz.guess(),
      language: localStorage.getItem('lang'),
      format,
      installation_id: this.installation.info.id,
    };

    try {
      const company = await companyModule.getCompanyInfo();
      const filetype = format === 'excel' ? 'xlsx' : 'pdf';
      const filename = `${templatesFilenameLanguage()}_${company.entity_name}_DfB_${data.installation_id}_items_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}.${filetype}`.replace(/ /g, '_');
      const exportFile = await installationsModule.getInstallationSideviewItemsExport(data);
      const file = new File([exportFile], filename);
      FileSaver.saveAs(file);
    } finally {
      this.isDownloadingExport = false;
    }
  }


  editInstallationItem (item: any){
    commonModule.showModal({ name: 'edit-installation-item-modal', payload: { installation_item: item, installation: this.installation }})
  }

  deleteInstallationItem (item: any){
    commonModule.showModal({ name: 'delete-installation-item-modal', payload: { installation_item: item, installation: this.installation }})
  }

};
